export default __webpack_public_path__ + "static/media/PE.a8d4525c.png";